<template>
  <div>
    <dashboard
    v-if="load"
      :activeaccounts="activeAccounts"
      :changerequest="changeRequest"
      :customerrequest="customerRequest"
      :packagedata="packageData"
      :pendingapplications="pendingApplications"
      :networkdata="networkData"
      :networkspeeds="networkSpeeds"
      :networks="allNetworks"
    ></dashboard>
  </div>
</template>

<script>
import Api from "@/services/Api";
import Dashboard from "@/components/ispDashboard.vue";

export default {
  components: {
    dashboard: Dashboard
  },
  data() {
    return {
      loadKey: 0,
      load: false,
      activeAccounts: [],
      changeRequest: [],
      customerRequest: [],
      packageData: [],
      pendingApplications: [],
      networkData: [],
      networkSpeeds: [],
      allNetworks: []
    };
  },
  async created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getActiveAccounts();
      await this.getActiveChangeRequests();
      await this.getPendingApplications();
      await this.getActiveCustomerRequests();
      await this.getServiceAccountBySpeed();
      await this.getNetworkData();
      this.loadKey += 1
      this.load = true
    },
    async getActiveAccounts() {
      await Api().get('/customer/serviceAccounts/allActive/oneDevice/count')
        .then(response=>{
            this.activeAccounts = response.data;
        })
      // await Api()
      //   .get("/customer/serviceAccounts/active/count")
      //   .then(response => {
      //     this.activeAccounts = response.data;
      //   });
    },
    async getActiveChangeRequests() {
      await Api()
        .get("/customer/changerequest/active/count")
        .then(response => {
          this.changeRequest = response.data;
        });
    },
    async getActiveCustomerRequests() {
      await Api()
        .get("/customer/endCustomerRequests/open/count")
        .then(response => {
          this.customerRequest = response.data;
        });
    },
    async getNetworkData(){
      await Api().get('/customer/locationNetwork/statistics')
      .then(response=>{
        this.allNetworks = response.data
      })
    },
    async getServiceAccountBySpeed() {
      await Api()
        .get("/customer/serviceAccounts/active/bySpeed")
        .then(async response => {
          let speedProfiles = [
            ...new Set(
              response.data.map(
                item => item.packagesIsp.packagesFno.speedProfileId
              )
            )
          ];
          let networks = [
            ...new Set(
              response.data.map(
                item => item.location.locationNetworkId
              )
            )
          ];
          this.packageData = [];
          await speedProfiles.map(x => {
            let find = response.data.find(
              z => z.packagesIsp.packagesFno.speedProfile.id === x
            );
            this.packageData.push({
              id: x,
              speedProfile: find.packagesIsp.packagesFno.speedProfile,
              colour: find.packagesIsp.packagesFno.speedProfile.colour,
              count: response.data.filter(
                y => y.packagesIsp.packagesFno.speedProfileId === x
              ).length
            });
          });
          this.packageData.sort((a, b) =>
            a.speedProfile.downloadMbps > b.speedProfile.downloadMbps
              ? 1
              : b.speedProfile.downloadMbps > a.speedProfile.downloadMbps
              ? -1
              : 0
          );

          this.networkData = []
await networks.map(x => {
            let find = response.data.find(
              z => z.location.locationNetwork.id === x
            );
            this.networkData.push({
              id: x,
              locationNetwork: find.location.locationNetwork,
              count: response.data.filter(
                y => y.location.locationNetworkId === x
              ).length
            });
          });
          // await networks.map(x => {
          //   let find = response.data.find(
          //     z => z.location.locationNetwork.id === x
          //   );
          //   this.networkData.push({
          //     id: x,
          //     locationNetwork: find.location.locationNetwork,
          //     count: response.data.filter(
          //       y => y.location.locationNetworkId === x
          //     ).length
          //   });
          // });
          this.networkData.sort((a, b) =>
            a.count < b.count
              ? 1
              : b.count < a.count
              ? -1
              : 0
          );

          this.networkSpeeds = []

          for (let a=0; a<this.packageData.length;a++){
              let obj = {
                  speedProfileId: this.packageData[a].speedProfile.id,
                  label: this.packageData[a].speedProfile.name,
                  colour: this.packageData[a].speedProfile.colour,
                  backgroundColor: '',
                  borderColor: '',
                  borderWidth: 1,
                  data: []
              }
              this.networkSpeeds.push(obj)
          }

          for (let b=0; b<this.networkData.length;b++){
              for (let c=0; c<this.networkSpeeds.length;c++){
                  let count = await response.data.filter(d=>d.location&&d.location.locationNetworkId===this.networkData[b].locationNetwork.id&&
                  d.packagesIsp.packagesFno.speedProfileId===this.networkSpeeds[c].speedProfileId).length
                  await this.networkSpeeds[c].data.push(count)
              }
          }
        });
    },
    async getPendingApplications() {
      await Api()
        .get("/customer/applications/pending/count")
        .then(response => {
          this.pendingApplications = response.data;
        });
    }
  }
};
</script>

<style>
</style>